
(function(){
 const overlay=document.querySelector('[data-airaa-search-overlay]');
 const input=document.querySelector('[data-airaa-search-input]');
 const results=document.querySelector('[data-airaa-search-results]');
 if(!overlay||!input||!results)return;
 const esc=s=>String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
 let timer;
 async function search(q){
   if(!q.trim()){results.innerHTML='';return}
   try{
    const r=await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide');
    const d=await r.json(); const ps=d.resources?.results?.products||[];
    results.innerHTML=ps.map(p=>`<a class="airaa-search-card" href="${esc(p.url)}"><img loading="lazy" src="${esc(p.image)}" alt="${esc(p.title)}"><div><b>${esc(p.title)}</b><span>${esc(p.price)}</span></div></a>`).join('') || '<p style="color:#aaa;grid-column:1/-1">No products found.</p>';
   }catch(e){results.innerHTML='<p style="color:#aaa;grid-column:1/-1">Search unavailable. Please try again.</p>'}
 }
 function open(){overlay.classList.add('is-open');document.body.style.overflow='hidden';input.focus()}
 function close(){overlay.classList.remove('is-open');document.body.style.overflow=''}
 document.querySelectorAll('[data-airaa-search-open]').forEach(b=>b.addEventListener('click',open));
 document.querySelectorAll('[data-airaa-search-close]').forEach(b=>b.addEventListener('click',close));
 overlay.addEventListener('click',e=>{if(e.target===overlay)close()});
 input.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(()=>search(input.value),180)});
 document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
})();

/* V27 collection filter drawer */
(function(){
  const panel=document.querySelector('[data-filter-panel]');
  const backdrop=document.querySelector('[data-filter-close]');
  if(!panel) return;
  const openers=document.querySelectorAll('[data-filter-open]');
  const close=()=>{panel.classList.remove('is-open');if(backdrop)backdrop.classList.remove('is-open');panel.setAttribute('aria-hidden','true');openers.forEach(b=>b.setAttribute('aria-expanded','false'));document.body.style.overflow=''};
  const open=()=>{panel.classList.add('is-open');if(backdrop)backdrop.classList.add('is-open');panel.setAttribute('aria-hidden','false');openers.forEach(b=>b.setAttribute('aria-expanded','true'));document.body.style.overflow='hidden'};
  openers.forEach(b=>b.addEventListener('click',open));
  document.querySelectorAll('[data-filter-close]').forEach(b=>b.addEventListener('click',close));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  panel.querySelectorAll('input[type="checkbox"]').forEach(input=>input.addEventListener('change',()=>{
    const label=input.closest('.filter-option'); if(label) label.classList.toggle('is-active',input.checked);
  }));
})();
